import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccessDeniedComponent implements OnInit {
  preloader:boolean = true;
  mailText:string = "";
  errorSubMessage:string="";
  errorBodyMessage:string="";

  constructor() { }

  ngOnInit(): void {
    this.preloader = false;
    
  }

  
}
